// extracted by mini-css-extract-plugin
export default {"text":"mVSgijPWUfpKwOBgwrWf","heading":"hV6PO0V_9u3An8axGCxt","container":"ch74iyqjmydxI8Ill_jj"};